exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n/** \n* Пагинация =====================================================\n*/\n/**\n* Хлебные крошки\n*/\n.text-center[data-v-2c786868] {\n  text-align: center;\n}\n.positions .positions__wrapper[data-v-2c786868] {\n  width: 683px;\n}\n.positions .positions__wrapper--border[data-v-2c786868] {\n  border: 2px dashed #00afa1;\n}\n.positions .positions__wrapper--background-gray[data-v-2c786868] {\n  background: #fafafa;\n}\n.positions .positions__image[data-v-2c786868] {\n  margin: 63px 53px;\n}", ""]);

// exports
